var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilledHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.61924 7.93195C-0.138085 6.17459 -0.13804 3.32534 1.61929 1.568C3.37664 -0.189345 6.22588 -0.189333 7.98324 1.56803C9.74059 -0.189317 12.5899 -0.189305 14.3472 1.56806C16.1046 3.32542 16.1046 6.17466 14.3473 7.932L14.3277 7.95147L8.7787 13.5004C8.33936 13.9398 7.62705 13.9398 7.18771 13.5004L1.61924 7.93195Z",
    fill: "#2F4858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledHeart);
export default __webpack_public_path__ + "static/media/filled_heart.ef1f2e19f2827c2d1f0d7fa04b0171a2.svg";
export { ForwardRef as ReactComponent };